import { render, staticRenderFns } from "./Trafostation.vue?vue&type=template&id=b0487a26&scoped=true&"
import script from "./Trafostation.vue?vue&type=script&lang=js&"
export * from "./Trafostation.vue?vue&type=script&lang=js&"
import style0 from "./Trafostation.vue?vue&type=style&index=0&id=b0487a26&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0487a26",
  null
  
)

component.options.__file = "Trafostation.vue"
export default component.exports